module.exports = __webpack_public_path__ + "static/img/007_TO8_1499_og.74ffbf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/007_TO8_1499_og.jpg
// module id = u9jf
// module chunks = 0